import FAQSection from "@/components/common/sections/FAQ";

export default function WebHostingPage() {
    const marketing = [
        {
            question: "What is Simple SEO?",
            answer: "Search Engine Optimization or SEO is a series of actions done to a website – or web page –to boost its visibility on search engines like Google, Yahoo, or Bing. Some of these actions include targeting relevant keywords, fixing broken links, and more. <br /><br />Simple SEO is our intuitive tool built to improve your website’s SEO score. It provides actionable tips and reports to make your site search engine-friendly."
        },
        {
            question: "Why are keywords important? How do I choose the right one?",
            answer: "Keywords refer to words and phrases that online users enter into search engines. They can be generic, short-tail keywords consisting of one to two words or more specific long-tail keywords. <br /><br />Simple SEO analyses keywords your competitors are ranking for. The goal is to determine their keyword strategy – and how you can “reverse-engineer” it for your website."
        },
        {
            question: "How to add a keyword in Simple SEO?",
            answer: "Log in to your Account Manager and go to Simple SEO. Then, click Manage to log in to your Online Marketing Hub account. Look for the 'Open' button in your Business Profile Progress. Finally, add your keywords to the allocated field."
        },
        {
            question: "How do I get to the first page of search engines?",
            answer: "You can get to the first page of search engines in at least six months of applying technical, on-page, and off-age SEO strategies. Of course, this is not guaranteed and requires continuous effort. <br /><br />Simple SEO helps you achieve this by providing step-by-step SEO actions. You can also run regular health checkups on your website to determine what areas need to be optimised."
        },
         {
            question: "Will you manage SEO for me?",
            answer: "While Simple SEO is a do-it-yourself solution, we also offer a do-it-for-you service. <br /><br />With Managed SEO, you get a dedicated specialist to optimise your site – from fixing broken links, keyword research, and more. You’ll also get progress reports to compare with your initial SEO scores."
        }
    ];

    return (
        <div>
            <FAQSection faqs={marketing} />
        </div>
    );
}